// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"223":"6a45aa61","453":"b4bc9ff5"}[chunkId] + ".chunk.js");